// crewbit-admin/src/hooks/useLeaseBoundariesByMonth.ts
//
// Schedule Module Phase C C3 — lease-boundary aggregation hook (admin pair).
// Body byte-equivalent to mobile crewbit-mobile/hooks/useLeaseBoundariesByMonth.ts
// modulo import paths (per feedback_admin_pair_must_match_mobile_body.md).
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §12.

import { useMemo } from 'react';

export type LeaseBoundaryKind = 'start' | 'end' | 'both';

export interface UseLeaseBoundariesByMonthInput {
  monthStart: string;
  businessId?: string;
  enabled?: boolean;
}

export interface UseLeaseBoundariesByMonthResult {
  byDate: Map<string, LeaseBoundaryKind>;
  loading: boolean;
}

export function useLeaseBoundariesByMonth(
  _input: UseLeaseBoundariesByMonthInput,
): UseLeaseBoundariesByMonthResult {
  return useMemo(() => ({ byDate: new Map(), loading: false }), []);
}
